import api from 'api'
import { toCamelcaseKeys } from 'lib/string'

export type AdminBlockAction = 'block' | 'unblock'

export type BlockActionParams = {
  companyId: number
  workerId: number
  action: AdminBlockAction
  reason: string
}

export type BlockActionResponse = {
  companyId: number
  workerId: number
  blocked: boolean
  action: AdminBlockAction
}

export const postBlockAction = async ({
  companyId,
  workerId,
  ...body
}: BlockActionParams): Promise<BlockActionResponse> => {
  const result = await api.post(
    `/admin/company/${companyId}/worker/${workerId}/block_action`,
    body
  )
  return toCamelcaseKeys(result.data, { deep: true }) as BlockActionResponse
}
